import { Injectable } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    private DEFAULT_DURATION = 5000;
    private DEFAULT_MODE: 'ios' | 'md' = 'ios';

    private DEFAULT_OPTIONS: ToastOptions = {
        mode: this.DEFAULT_MODE,
        duration: this.DEFAULT_DURATION,
        cssClass: 'toast-custom-class',
    };

    constructor(private toastController: ToastController) {}

    public async success(toastOption: ToastOptions): Promise<void> {
        const toast = await this.toastController.create({
            ...this.DEFAULT_OPTIONS,
            icon: 'assets/icon/check.svg',
            ...toastOption,
        });
        toast.present();
    }

    public async info(toastOption: ToastOptions): Promise<void> {
        const toast = await this.toastController.create({
            ...this.DEFAULT_OPTIONS,
            color: 'primary',
            cssClass: 'toast-custom-class black',
            ...toastOption,
        });
        toast.present();
    }

    public async error(toastOption: ToastOptions): Promise<void> {
        const toast = await this.toastController.create({
            color: 'danger',
            position: 'top',
            ...this.DEFAULT_OPTIONS,
            ...toastOption,
        });
        toast.present();
    }
}
